<template>
  <ActionGeneric :to="to" label="Visualizza" iconClass="fas fa-eye" />
</template>

<script>

export default {
  name: 'action-show',
  components: {
    ActionGeneric: () => import('./ActionGeneric'),
  },
  props: {
    to: {
      type: Object,
    },
  },
};

</script>
